import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const show = () => true;
const hide = () => false;

export default createReducer(initialState, {
  [actionTypes.SHOW_ADD_DRIVER_LICENCE]: show,
  [actionTypes.HIDE_ADD_DRIVER_LICENCE]: hide,
});
